<div [formGroup]="form">
    <div class="editor-tag" (click)="focusTagInput()">
        <span class="tag-item" *ngFor="let tag of tags">
            {{ tag }}
            <span class="remove-tag" (click)="removeTag(tag)">×</span>
        </span>

        <input
            #tagInput
            type="text"
            class="input-tag"
            placeholder="Agregar opción"
            formControlName="tag"
            (keyup)="onKeyUp($event)"
        />
    </div>
</div>
